import { render, staticRenderFns } from "./DialogUpdateContact.vue?vue&type=template&id=520ad4dd&scoped=true"
import script from "./DialogUpdateContact.vue?vue&type=script&lang=js"
export * from "./DialogUpdateContact.vue?vue&type=script&lang=js"
import style0 from "./DialogUpdateContact.vue?vue&type=style&index=0&id=520ad4dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ad4dd",
  null
  
)

export default component.exports